@if (props.icon; as icon) {
  <fa-icon [icon]="['fas', icon]" class="me-1"></fa-icon>
}
@if (props.label; as label) {
  <div class="pseudo-label" [innerHTML]="label"></div>
}
@if (props.text; as text) {
  <span [innerHTML]="text"></span>
}
@if (props.text2; as text2) {
  <p [innerHTML]="text2" class="mt-2"></p>
}
